export default function ($mdThemingProvider) {
    $mdThemingProvider.definePalette('amazingPaletteName', {
        '50': '337ab7',
        '100': '337ab7',
        '200': '337ab7',
        '300': '337ab7',
        '400': '337ab7',
        '500': '337ab7',
        '600': '337ab7',
        '700': '337ab7',
        '800': '337ab7',
        '900': '337ab7',
        'A100': '337ab7',
        'A200': '337ab7',
        'A400': '337ab7',
        'A700': '337ab7',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light
        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
            '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });
    $mdThemingProvider.theme('default')
        .primaryPalette('amazingPaletteName')


    $mdThemingProvider.definePalette('brownPalette', {
        '50': '795548',
        '100': '795548',
        '200': '795548',
        '300': '795548',
        '400': '795548',
        '500': '795548',
        '600': '5D4037',
        '700': '5D4037',
        '800': '4E342E',
        '900': '4E342E',
        'A100': 'BCAAA4',
        'A200': 'BCAAA4',
        'A400': 'BCAAA4',
        'A700': 'BCAAA4',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light
        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
            '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });
    $mdThemingProvider.theme('brown')
        .primaryPalette('brownPalette')
};





/** WEBPACK FOOTER **
 ** ./js/config/material_interceptor.js
 **/